import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import '../../../../scss/common/inputs.scss';
const RadioButtons = observer(({
  elements = [],
  renderElement = null,
  title = '',
  description = null,
  required = false,
  singleRow = false,
  onChangeRadio = null,
  defaultValue = null
}) => {
  const [value, setValue] = useState(defaultValue ? defaultValue : elements[0].value);
  const onChange = newValue => {
    setValue(newValue);
    if (onChangeRadio) {
      onChangeRadio(newValue);
    }
  };
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  return /*#__PURE__*/React.createElement("div", {
    className: `cms-input cms-radio-buttons-container`
  }, /*#__PURE__*/React.createElement("div", {
    className: "cms-input-title cms-radio-buttons-title-container"
  }, title, required ? '*' : ''), description ? /*#__PURE__*/React.createElement("div", {
    className: "cms-input-description cms-radio-buttons-input-description"
  }, description) : null, /*#__PURE__*/React.createElement("div", {
    className: `cms-all-radios  ${singleRow ? 'single-row' : ''}`
  }, elements.map((el, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: `single-checkmark-container ${el.value === value ? 'checked' : ''}`,
      onClick: e => onChange(el.value)
    }, /*#__PURE__*/React.createElement("span", {
      className: "checkmark"
    }), /*#__PURE__*/React.createElement("span", {
      className: "checkmark-label"
    }, renderElement ? renderElement(el) : el.label));
  })));
});
export default RadioButtons;